import { useState } from 'react';
import { createComentario } from '../../../../services/comentarioDenunciaService';
import './FormularioComentario.css';

import imagen from '../../../../assets/imagen.webp';
import imageCompression from 'browser-image-compression';
import PopupMensaje from '../../../../iu/popupMensaje/PopupMensaje';

import { useUser } from '../../../../userContext';


const FormularioComentario = ({ idDenuncia, cerrar, EnviadoPorUsuario }) => {

    const { token } = useUser();
    const [comentario, setComentario] = useState('');
    const [fotos, setFotos] = useState([]);
    const [previewFotos, setPreviewFotos] = useState([]);
    const [popupMensaje, setPopupMensaje] = useState('');
    const [popupKey, setPopupKey] = useState(0);

    const handleFileChange = async (e) => {
        if (e.target.files.length <= 3) {
            const files = e.target.files;
            const compressedFiles = [];
            const filePreviews = [];

            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                const options = {
                    maxSizeMB: 1,
                    maxWidthOrHeight: 1024,
                    useWebWorker: true
                };

                try {
                    const compressedFile = await imageCompression(file, options);
                    compressedFiles.push(compressedFile);
                    const preview = URL.createObjectURL(compressedFile);
                    filePreviews.push(preview);
                } catch (error) {
                    console.error('Error comprimiendo la imagen:', error);
                }
            }

            setFotos(compressedFiles);
            setPreviewFotos(filePreviews);
        } else {
            setPopupMensaje('Solo se pueden subir hasta 3 fotografías');
            setPopupKey(prevKey => prevKey + 1);
            e.target.value = null;

        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!comentario) {
            setPopupMensaje('Por favor llena todos los campos.');
            setPopupKey(prevKey => prevKey + 1);
            return;
        }

        const formData = new FormData();
        formData.append('comentario', comentario);
        formData.append('idDenuncia', idDenuncia);
        formData.append('enviadoPorUsuario', EnviadoPorUsuario);

        for (let i = 0; i < fotos.length; i++) {
            formData.append('imagenes', fotos[i]);
        }


        try {
            await createComentario({ token, formData });
            setPopupMensaje('Comentario creado exitosamente');
            setPopupKey(prevKey => prevKey + 1);
            setComentario('');
            setFotos([]);
            setPreviewFotos([]);
            setComentario('');
            setPreviewFotos([]);
            cerrar();
        } catch (error) {
            console.error('Error de red:', error);
            setPopupMensaje('Error al crear el comentario, intenta de nuevo más tarde');
            setPopupKey(prevKey => prevKey + 1);
        }
    };


    const handlePopupClose = () => {
        setPopupMensaje('');
    };

    const handleCerrarFormulario = () => {
        setComentario('');
        setPreviewFotos([]);
        cerrar();
    };
    return (
        <div className='popup-overlay'>
            <div className='comentario-form-popup'>
                <div className='comentario-title'>
                    Comentario Denuncia tipo: {EnviadoPorUsuario ? 'Enviado por Usuario' : 'Policía'}
                </div>
                <div className='comentario-space'>
                    <label>Comentario de la denuncia (obligatorio)</label>
                    <textarea
                        className='crear-denuncia-descripcion'
                        value={comentario}
                        onChange={(e) => setComentario(e.target.value)}
                        required
                        placeholder='Escribe aquí la descripción de los hechos'
                    ></textarea>
                </div>
                <div className='comentario-space'>
                    <label>Fotografías (máximo 3)</label>
                    {previewFotos.length > 0 && (
                        <div className='crear-denuncia-fotos'>
                            {previewFotos.map((foto, index) => (
                                <img
                                    key={index}
                                    className='crear-denuncia-foto'
                                    src={foto}
                                    alt={`Foto ${index + 1}`}
                                />
                            ))}
                        </div>
                    )}
                    <label className="custom-file-upload">
                        <input
                            type='file'
                            multiple
                            accept='image/*'
                            onChange={handleFileChange}
                        />
                        Seleccionar fotos
                        <img className='icono-imagen' src={imagen} alt='imagen icono' />
                    </label>
                </div>
                <div className='contenedor-horizontal'>
                    <button className='boton-secundario' onClick={handleCerrarFormulario} >Sin comentarios</button>
                    <button className='boton-primario' type='button' onClick={handleSubmit}>Enviar comentario</button>
                </div>
            </div>
            {popupMensaje && (
                <>
                    <div className="popup-overlay"></div>
                    <PopupMensaje
                        key={popupKey}
                        mensaje={popupMensaje}
                        onClose={handlePopupClose}
                    />
                </>
            )}
        </div>
    );
};

export default FormularioComentario;